import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { LabelGrouping } from '@aibees/elephant/types/label';
import * as SX from './sx';

export const CONFIG: TableFilterSelectOption[] = [
  {
    key: LabelGrouping.ALL,
    value: 'All Types',
  },
  {
    key: LabelGrouping.COMPANY,
    value: 'Company',
    icon: 'business',
    iconSx: SX.companyIcon,
  },
  {
    key: LabelGrouping.PEOPLE,
    value: 'People',
    icon: 'people-outline',
    iconSx: SX.contactIcon,
  },
];
